<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-popup
      fullscreen
      class="profile-card"
      title="Editor"
      :active.sync="flag"
    >
      <iframe
        :src="src"
        fullscreen
        frameBorder="0"
        id="editorGala"
        class="editor-iframe"
      ></iframe>
    </vs-popup>
    <!--<vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $store.state.AppActiveUser.userId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>-->

    <div id="user-data" v-if="user_data">
<!--      {{user_data}}-->
      <vx-card  class="mb-base">
        <!-- Avatar -->
        <div class="parent">
          <img class="image1 w-full" :src="require('@/assets/images/header/' + profileBannerImage + '.png')">
          <img 
            v-if="userAvatarUrl" 
            key="onlineImg" 
            :src="userAvatarUrl" 
            alt="user-img" 
            class="rounded-full shadow-md cursor-pointer block image2" 
            @error="$event.target.src=defaultAvatarFallback" 
          />
          <div   class="rounded-full shadow-md cursor-pointer block image3" >
             <div class="ml-1 mt-1">  <img class="refresh-img" @click="syncGbData" key="onlineImg" src="@/assets/images/header/refresh-ccw 1.png" alt="user-img"   /></div>

           </div>
           <h1 class="items-center mt-4 text-margin" >
           <b>{{user_data.firstName}} {{user_data.lastName}}</b>
           </h1>
          <p class="items-center mt-4 text-margin" >
            Company: <b>{{user_data.company[0].name}}</b>
          </p>
          <p class="items-center mr-12 mt-4" style="float:right;">
            <vs-button
                              icon-pack="feather"
                              class="mr-4"
                              @click="launchEditor(user_data.company[0].name)"
                            >Launch Editor</vs-button>
          </p>
        <br>
        <br>
        <br>
        <br>

        </div>
<!--        <div class="vx-row">-->
<!--          &lt;!&ndash; Avatar Col &ndash;&gt;-->
<!--          <div class="vx-col" id="avatar-col">-->
<!--            <div class="img-container mb-4">-->
<!--              <img :src="user_data.avatar" class="rounded w-full" />-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; Information - Col 1 &ndash;&gt;-->
<!--          <div class="vx-col flex-1" id="account-info-col-1">-->
<!--            <table>-->

<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t("profile.p2") }}</td>-->
<!--                <td>{{ user_data.firstName }} {{ user_data.lastName }}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t("profile.p3") }}</td>-->
<!--                <td>{{ user_data.email }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">Email</td>-->
<!--                <td>{{ user_data.email }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--            </table>-->
<!--          </div>-->
<!--          &lt;!&ndash; /Information - Col 1 &ndash;&gt;-->

<!--          &lt;!&ndash; Information - Col 2 &ndash;&gt;-->
<!--          <div class="vx-col flex-1" id="account-info-col-2">-->
<!--            <table>-->
<!--              <tr>-->
<!--                <td class="font-semibold">{{ $t("profile.p4") }}</td>-->
<!--                <td>{{ user_data.status }}</td>-->
<!--              </tr>-->
<!--              &lt;!&ndash;<tr>-->
<!--                <td class="font-semibold">User Type</td>-->
<!--                <td>{{ user_data.user_type }}</td>-->
<!--              </tr>&ndash;&gt;-->
<!--              <tr v-if="user_data.company">-->
<!--                <td class="font-semibold">{{ $t("profile.p5") }}</td>-->
<!--                <td>{{ user_data.company[0].name }}</td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </div>-->
<!--          &lt;!&ndash; /Information - Col 2 &ndash;&gt;-->
<!--          <div class="vx-col w-full flex" id="account-manage-buttons">-->
<!--            <div v-if="companyName==='GALA.GAMES'">-->
<!--              <vs-button-->
<!--                icon-pack="feather"-->
<!--                class="mr-4 items-end"-->
<!--                @click="launchEditor"-->

<!--              >Launch Editor</vs-button>-->
<!--              <vs-icon  @click="syncGbData" icon-pack="feather" icon="icon-refresh-ccw" title="Sync User Data"/>-->
<!--            </div>-->
<!--            <div v-else-if="companyName==='Datarmony'">-->
<!--              <vs-button-->
<!--                icon-pack="feather"-->
<!--                class="mr-4"-->
<!--                @click="launchEditor(companyName)"-->
<!--              >Launch Editor</vs-button>-->
<!--              <vs-icon  @click="syncGbData" icon-pack="feather" icon="icon-refresh-ccw" title="Sync User Data"/>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              <vs-button-->
<!--                  icon-pack="feather"-->
<!--                  class="mr-4"-->
<!--                  @click="launchEditor"-->
<!--              >Launch Editor</vs-button>-->
<!--              <vs-icon  @click="syncGbData" icon-pack="feather" icon="icon-refresh-ccw" title="Sync User Data"/>-->
<!--            </div>-->

<!--            &lt;!&ndash;<vs-button-->
<!--              type="border"-->
<!--              color="danger"-->
<!--              icon-pack="feather"-->
<!--              icon="icon-trash"-->
<!--              @click="confirmDeactivateRecord"-->
<!--              >Deactivate Account</vs-button-->
<!--            >&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('profile.p21')" class="mb-base">
            <table class="mt-2">
              <tr >
                <td class="col-md-6" >
                  <div class="flex items-center">
                  <feather-icon icon="MailIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                  <span class="font-semibold">Email :</span>
                </div>
                </td>
                <td class="col-md-6 "><span class="ml-12">{{user_data.email}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="SmartphoneIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold ">Phone :</span>
                  </div>
                </td>
                <td class="col-md-6"><span class="ml-12">{{user_data.mobile}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="UserIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Gender :</span>
                  </div>
                </td>
                <td class="col-md-6"><span class="ml-12">{{user_data.gender}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="CalendarIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Date of Birth :</span>
                  </div>
                </td>
                <td class="col-md-6"><span class="ml-12">{{formatDate(user_data.dob)}}</span></td>
              </tr>
              <tr>
                <td class="col-md-6" >
                  <div class="flex items-center">
                    <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span class="font-semibold">Status :</span>
                  </div>
                </td>
                <td class="col-md-6 "><span class="ml-12"><vs-chip class="bg-primary ml-12" style="color: white"><ul><li>{{user_data.status}}</li></ul></vs-chip></span></td>
              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('socialLink')" class="mb-base" style="height: 230px;">
            <table class="mt-4">
              <tr>
                <td class="col-md-6" v-if="user_data.facebook" >
                  <div class="flex items-center">
                    <feather-icon icon="FacebookIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.facebook}}</a></span>
                  </div>
                </td>

              </tr>
              <tr>
                <td class="col-md-6" v-if="user_data.twitter">
                  <div class="flex items-center">
                    <feather-icon icon="TwitterIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.twitter}}</a></span>
                  </div>
                </td>

              </tr>
              <tr>
                <td class="col-md-6" v-if="user_data.linkedin">
                  <div class="flex items-center">
                    <feather-icon icon="LinkedinIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.linkedin}}</a></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="col-md-6" v-if="user_data.linkedin">
                  <div class="flex items-center">
                    <feather-icon icon="GithubIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.linkedin}}</a></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="col-md-6 " v-if="user_data.linkedin">
                  <div class="flex items-center">
                    <feather-icon icon="GlobeIcon" svgClasses="h-5 w-5" class="cursor-pointer  mr-2 mt-1 ml-4" />
                    <span ><a>{{user_data.linkedin}}</a></span>
                  </div>
                </td>
              </tr>

            </table>
          </vx-card>
        </div>
      </div>

      <!-- Permissions -->
      <!--<vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Permissions</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full permissions-table">
            <tr>
              &lt;!&ndash;
                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               &ndash;&gt;
              <th
                class="font-semibold text-base text-left px-3 py-2"
                v-for="heading in [
                  'Module',
                  'Read',
                  'Write',
                  'Create',
                  'Delete'
                ]"
                :key="heading"
              >
                {{ heading }}
              </th>
            </tr>

            <tr v-for="(val, name) in user_data.permissions" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td
                v-for="(permission, name) in val"
                class="px-3 py-2"
                :key="name + permission"
              >
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr>
          </table>
        </div>
      </vx-card>-->
    </div>
  </div>
</template>

<script>
  // import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
  import i18n from "@/i18n/i18n";
  export default {
    data () {
      return {
        user_data: null,
        user_not_found: false,
        userType: this.$store.state.AppActiveUser.userType,
        companyName:'',
        src:'',
        flag: false,
        profileBannerImage:''
      };
    },
    computed: {
      defaultAvatarFallback() {
        return "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='%23e2e8f0'/%3E%3Cpath d='M128 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0 16c42.6 0 128 21.4 128 64v32H0v-32c0-42.6 85.4-64 128-64z' fill='%2394a3b8'/%3E%3C/svg%3E";
      },
      userAvatarUrl() {
        let avatar = (this.user_data && this.user_data.avatar) || (this.activeUserInfo && this.activeUserInfo.avatar);
        
        // Return default avatar if the user has no avatar set
        if (!avatar) return this.defaultAvatarFallback; 
        
        let finalUrl = avatar;
        
        // FIX: Replaced old bucket with gtbrdd-storage in us-west-2
        if (!finalUrl.startsWith('http')) {
            finalUrl = 'https://gtbrdd-storage.s3.us-west-2.amazonaws.com/editor/profile-pictures/' + finalUrl;
        }
        
        return encodeURI(finalUrl);
      },
      userAddress () {
        let str = "";
        for (const field in this.user_data.location) {
          str += `${field} `;
        }
        return str;
      },
      activeUserInfo () {
        return JSON.parse(localStorage.getItem('userInfo'));
      }
    },
    methods: {
      launchEditor(companyName){
        const payload ={
          accessToken:localStorage.getItem('accessToken'),
          email:this.user_data.email,
          userId:this.user_data.id
        }
        let gbuserId='';
        console.log('Sync Gb Data',payload);
        this.$store
            .dispatch("userManagement/gbDataFetch", payload)
            .then(res => {

               gbuserId=res.data.data[0]._id;
              if(companyName) {
                this.src = "https://editor.getboarded.com/oauth-callback?organization="+companyName+"&token="+localStorage.getItem('accessToken')+"&userId="+gbuserId;
              }
              else{
                this.src = "https://editor.getboarded.com/oauth-callback?organization=default&token="+localStorage.getItem('accessToken')+"&userId="+gbuserId;
              }
              this.flag = true;
              document.getElementById("editorGala").contentWindow.location.reload(true);

            })
            .catch(err => {
              console.error(err);
              this.$vs.notify({
                color: "danger",
                title: i18n.t('notification.user.profile.profileSynced.error.e1'),
                text:  i18n.t('notification.user.profile.profileSynced.error.e2')
              });

            });
        console.log(gbuserId);

      },
      getAvatarUrl(url) {
        if (!url) return '';
        if (url.startsWith('http')) return url;
        return 'https://getboarded-backup-new.s3.us-east-2.amazonaws.com/editor/profile-pictures/' + url;
      },
      syncGbData(){
        const payload ={
          accessToken:localStorage.getItem('accessToken'),
          email:this.user_data.email,
          userId:this.user_data.id
        }
        this.$vs.loading();
        console.log('Sync Gb Data',payload);
        
        this.$store
          .dispatch("userManagement/gbDataFetch", payload)
          .then(res => {
            if(res.data && res.data.data && res.data.data.length > 0) {
              let fetchedData = res.data.data[0];
              
              var image='';
              if(fetchedData.profilePictureUrl){
                image='https://gtbrdd-storage.s3.us-west-2.amazonaws.com/editor/profile-pictures/' + fetchedData.profilePictureUrl;
              }else{
                image=null;
              }
              
              let rawMobile = fetchedData.contactNumber ? String(fetchedData.contactNumber) : '';
              let safeMobile = rawMobile.replace(/\D/g, '').slice(-10);

              const updatePayload = {
                id: this.user_data.id,
                dob: fetchedData.dob,
                mobile: safeMobile,
                addLine1: fetchedData.address,
                twitter: fetchedData.twitterProfile,
                facebook: fetchedData.facebookProfile,
                gender: fetchedData.gender,
                instagram: fetchedData.linkedinProfile,
                avatar: image,
              }
              
              this.$store
                  .dispatch("userManagement/updateUser", updatePayload)
                  .then(() => {
                    // FIX: Clone the user data to safely update the local UI immediately! 
                    // This bypasses Vuex strict mode errors AND ignores cached server responses.
                    let clonedUser = JSON.parse(JSON.stringify(this.user_data));
                    clonedUser.avatar = image;
                    clonedUser.mobile = safeMobile;
                    clonedUser.dob = fetchedData.dob;
                    clonedUser.gender = fetchedData.gender;
                    this.user_data = clonedUser;
                      
                    this.$vs.notify({
                      color: "primary",
                      title: i18n.t('notification.user.profile.dataSynced.success.d1'),
                      text: i18n.t('notification.user.profile.dataSynced.success.d2')
                    });
                    this.$vs.loading.close();
                  }).catch(err => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: i18n.t('notification.user.profile.dataSynced.failed.d1'),
                  text: i18n.t('notification.user.profile.dataSynced.failed.d2')
                });
                this.$vs.loading.close();
              });
            }
          })
          .catch(err => {
            console.error(err);
            this.$vs.notify({
              color: "danger",
              title: i18n.t('notification.user.profile.profileSynced.error.e1'),
              text:  i18n.t('notification.user.profile.profileSynced.error.e2')
            });
            this.$vs.loading.close();
          });
      },
      
      formatDate(sentDate) {
        let date = new Date(sentDate)
        console.log("sent date", date);
        date = `${date.getFullYear()  }-${  date.getMonth() + 1  }-${  date.getDate()}`;
        return date;
      },
      confirmDeleteRecord () {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: i18n.t('notification.user.profile.confirm.c1'),
          text:  i18n.t('notification.user.profile.confirm.c2',{ username: this.user_data.username}),
          accept: this.deleteRecord,
          acceptText: "Delete"
        });
      },
      deleteRecord () {
        /* Below two lines are just for demo purpose */
        // this.$router.push({ name: "admin-user-list" });
        this.showDeleteSuccess();

        /* UnComment below lines for enabling true flow if deleting user */
        this.$store
          .dispatch("userManagement/removeRecord", this.user_data.id)
          .then(() => {
            this.$router.push({ name: "admin-user-list" });
            this.showDeleteSuccess();
          })
          .catch(err => {
            console.error(err);
          });
      },
      showDeleteSuccess () {
        this.$vs.notify({
          color: "success",
          title: i18n.t('notification.user.profile.removeRecord.success.r1'),
          text:  i18n.t('notification.user.profile.removeRecord.success.r2')
        });
      }
    },
    created () {
      // Register Module UserManagement Module
      /*if (!moduleUserManagement.isRegistered) {
        this.$store.registerModule("userManagement", moduleUserManagement);
        moduleUserManagement.isRegistered = true;
      }*/

    console.log('themeColor',localStorage.getItem("themeColor"));
     if(localStorage.getItem("themeColor")==='#9DCD5B'){
        this.profileBannerImage='header_img1'
      }
     else if(localStorage.getItem("themeColor")==='#6859B4'){
      this.profileBannerImage='header_img2'
    }
    else if(localStorage.getItem("themeColor")==='#3BA0BE'){
      this.profileBannerImage='header_img3'
    }else if(localStorage.getItem("themeColor")==='#E4D033'){
      this.profileBannerImage='header_img4'
    }else if(localStorage.getItem("themeColor")==='#EA7526'){
      this.profileBannerImage='header_img5'
    }else if(localStorage.getItem("themeColor")==='#C6211B'){
      this.profileBannerImage='header_img6'
    }else if(localStorage.getItem("themeColor")==='#F36677'){
      this.profileBannerImage='header_img7'
    }else if(localStorage.getItem("themeColor")==='#B3B3B3'){
      this.profileBannerImage='header_img8'
    }
     else if(localStorage.getItem("themeColor")==='#000066'){
       this.profileBannerImage='header_img9'
     }
    else {
      this.profileBannerImage='header_img1'
    }

      const usersId = this.$store.state.AppActiveUser.usersId;

      // const userType = this.$store.state.AppActiveUser.userType;
      this.$store
        .dispatch("userManagement/fetchUser", usersId)
        .then(res => {
          this.user_data = res;
       this.companyName=   window.$cookies.get('companyName');
          console.log("user data view", this.user_data);
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  };
</script>

<style lang="scss">
.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0rem;
}
.parent {
  position: relative;
  top: 0;
  left: 0;
}
.image1 {
  position: relative;
  top: 0;
  left: 0;

}
.image2 {
  position: absolute;
  top: 80px;
  left: 50px;
  height: 180px;
  width: 180px;
}
.image3 {
  position: absolute;
  top: 220px;
  left: 180px;
  height:35px;
  width:35px;
  background: #D0D5DD;
  border: 2px solid #FFFFFF;
  border-radius: 100px;
}
.text-margin{
  margin-left: 20%;
}
  #avatar-col {
    width: 10rem;
  }
  .editor-iframe {
    width: 100%;
    height: calc(100vh);
  }
  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: 0.8rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }
@media (max-width: 480px) {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 20px;
    left: 20px;
    height: 70px;
    width:70px;


  }
  .image3 {
    position: absolute;
    top: 60px;
    left: 70px;
    height:25px;
    width:25px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 35%;
    font-size: 12px;
  }
  .refresh-img{
    height: 15px;
  }
}

/* Media Query for low resolution  Tablets, Ipads */
@media (min-width: 481px) and (max-width: 767px) {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 40px;
    left: 50px;
    height: 100px;
    width: 100px;


  }
  .image3 {
    position: absolute;
    top: 110px;
    left: 120px;
    height:30px;
    width:30px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 30%;
  }
  .refresh-img{
    height: 20px;
  }
}

/* Media Query for Tablets Ipads portrait mode */
@media (min-width: 768px) and (max-width: 1024px){
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 40px;
    left: 50px;
    height: 100px;
    width: 100px;


  }
  .image3 {
    position: absolute;
    top: 110px;
    left: 120px;
    height:30px;
    width:30px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 30%;
  }
  .refresh-img{
    height: 20px;
  }
}

/* Media Query for Laptops and Desktops */
@media (min-width: 1025px) and (max-width: 1280px){
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .refresh-img{
    height: 15px;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 60px;
    left: 30px;
    height: 150px;
    width: 150px;
  }
  .image3 {
    position: absolute;
    top: 180px;
    left: 135px;
    height:25px;
    width:25px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 20%;

  }
}

/* Media Query for Large screens */
@media (min-width: 1281px) {
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 0rem;
  }
  .refresh-img{
    height: 15px;
  }
  .parent {
    position: relative;
    top: 0;
    left: 0;
  }
  .image1 {
    position: relative;
    top: 0;
    left: 0;

  }
  .image2 {
    position: absolute;
    top: 60px;
    left: 30px;
    height: 150px;
    width: 150px;
  }
  .image3 {
    position: absolute;
    top: 180px;
    left: 135px;
    height:25px;
    width:25px;
    background: #D0D5DD;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
  }
  .text-margin{
    margin-left: 20%;
  }
}





  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }


</style>
